var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"days-remaining-badge",on:{"click":_vm.navigateToSitePage}},[_vm._v(" "+_vm._s(_vm.daysRemainingText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }